import awards from "../../../de/shared/de.awards";
import branded_quotes from "../../../de/shared/de.branded-quotes";
import verticals from "./cn-consumer.verticals";

const pageFooter = ({ strings }) => {
    return {
        awards: {
            visible: true,
            title: {
                content: strings.awards_header_label,
                align: "center",
                type: "section-title"
            },
            panels: awards({ strings })
        },
        branded_quotes: {
            visible: true,
            title: {
                content: strings.branded_quotes_header_label,
                align: "center",
                type: "section-title"
            },
            panels: branded_quotes({ strings })
        },
        verticals: {
            visible: true,
            title: {
                content: strings.verticals_label,
                align: "center",
                type: "section-title"
            },
            panels: verticals({ strings })
        }
    };
};

export default ({ page, strings }) => {
    switch (page) {
        case "cn-consumer-404":
            return {
                page,
                helmet: {
                    meta_title: "网页未找到 | Rosetta Stone",
                    meta_description: "",
                    canonical_url: "https://www.rosettastone.cn/404/",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        case "cn-consumer-home":
            return {
                page,
                helmet: {
                    meta_title: "企业语言培训 | Rosetta Stone",
                    meta_description:
                        "企业语言培训 | Rosetta Stone: Rosetta Stone语言培训方案帮助员工提高商务英语和其它业务相关外语的语言能力。咨询价格",
                    canonical_url: "https://www.rosettastone.cn/",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        case "cn-consumer-dynamic-resources":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        case "cn-consumer-dynamic-content":
            return {
                page,
                helmet: {
                    meta_title: "",
                    meta_description: "",
                    canonical_url: "",
                    lang: "zh"
                },
                ...pageFooter({ strings })
            };
        default:
            return null;
    }
};
